import { apiClient } from '../apiClient';

/**
 * Common Audit Log function for Frontend
 * Calls backend API `/v1/admin/audit-logs` which invokes `writeAuditLog()`.
 * 
 * Rules:
 * - Must NOT throw errors that interrupt core business processes.
 * - Must NOT pass personal info (name, email, phone) or company details in metadata.
 */
export const writeAuditLog = async ({
  action,
  resourceType,
  resourceId = '',
  result = 'success',
  metadata = { source: 'admin_console' }
}) => {
  try {
    await apiClient.post('/v1/admin/audit-logs', {
      action,
      resourceType,
      resourceId,
      result,
      metadata
    });
  } catch (error) {
    console.error('Failed to record audit log:', error);
  }
};
